import { Button, makeStyles } from "@material-ui/core";
import React from "react";
import GreenTriangle from "../../items/veggies/greenTriangle.png";
import WhiteTriangle from "../../items/veggies/smwhitetriangle.png";
const useStyles = makeStyles((theme) => ({
  mobileButton: {
    height: "80px",
    width: "100%",
    backgroundColor: "white",
  },
  mobileButtonActive: {
    height: "80px",
    width: "100%",
    backgroundColor: theme.palette.primary.main,
  },
}));

export default function MobileButton({ button, id, title, img, setButton }) {
  const classes = useStyles();
  const contained = id === button ? "primary" : "";
  return (
    <Button
      variant="contained"
      color={contained}
      className={`${
        button === id ? classes.mobileButtonActive : classes.mobileButton
      }`}
      onClick={setButton}
    >
      <img src={img} alt={title} />
      {title}
      <div style={{ flexGrow: 1 }} />
      {id === button ? (
        <img src={WhiteTriangle} alt="white triangle" />
      ) : (
        <img src={GreenTriangle} alt="green tri" />
      )}
    </Button>
  );
}
